<template>
  <div class="bulk-delete-article-watches-modal">
    <h3>{{ tStatic('bulkDeleteArticleWatchesModalTitle') }}</h3>
    <p>
      {{ tStatic('bulkDeleteArticleWatchesModalDescription').replace('{count}', options.ids.length) }}
    </p>
    <div class="bulk-delete-modal__actions">
      <oie-base-button
        :text="tStatic('bulkDeleteArticleWatchesModalConfirmButtonLabel')"
        css-classes="button--dark-red"
        @click="deleteBulkArticleWatches"></oie-base-button>
      <oie-base-button
        :text="tStatic('modalCancel')"
        css-classes="button--true-ghost"
        @click="closeModal"></oie-base-button>
    </div>
  </div>
</template>

<script>
import httpService from '@/core/http-service'

export default {
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  methods: {
    async deleteBulkArticleWatches() {
      try {
        // Delete multiple article watches
        const deletePromises = this.options.ids.map(id =>
          httpService.delete('article-watch/delete', { id })
        )

        await Promise.all(deletePromises)

        this.options.onHide()
        this.closeModal()
      } catch (error) {
        console.error('Error deleting article watches:', error)
        // Handle error appropriately
      }
    },
    closeModal() {
      this.publish('modal.hide.bulk-delete-article-watches')
    }
  }
}
</script>

<style lang="scss">
.bulk-delete-article-watches-modal {
  > h3 {
    @include h3-bold;
    margin: 0;
  }

  > p {
    margin: 1rem 0 1.5rem 0;
  }
}

.bulk-delete-modal__actions {
  display: flex;
  gap: 1rem;
}
</style>
